import { render, staticRenderFns } from "./clients-activity.vue?vue&type=template&id=b89113c4"
import script from "./clients-activity.vue?vue&type=script&lang=js"
export * from "./clients-activity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b89113c4')) {
      api.createRecord('b89113c4', component.options)
    } else {
      api.reload('b89113c4', component.options)
    }
    module.hot.accept("./clients-activity.vue?vue&type=template&id=b89113c4", function () {
      api.rerender('b89113c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/dashboard/components/clients-activity.vue"
export default component.exports